<a *ngIf="entities.length>1" (click)="$event.preventDefault();getEntity()" href="#">{{selectedGroup}}</a>
<a *ngIf="entities.length==1" (click)="$event.preventDefault()" href="#">{{selectedGroup}}</a>